import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
}

/*
 * The Hundred Step mark: a rising staircase inside a rounded tile,
 * with a small light-green "step" dot about to land on the top stair.
 * The first <rect> is the tile, so other components can recolor it.
 */
export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            className={cn('size-8', className)}
        >
            <rect width='32' height='32' rx='9' className='fill-primary' />
            <path
                d='M6.5 25.5V21h4.75v-4.75H16V11.5h4.75V6.75h4.75V25.5Z'
                className='fill-primary-foreground'
            />
            <path
                d='M6.5 21h4.75v-4.75H16V11.5h4.75V6.75h4.75'
                fill='none'
                strokeWidth='1.2'
                strokeLinejoin='round'
                className='stroke-primary/25'
            />
            <circle cx='13.6' cy='11.2' r='2.1' className='fill-[oklch(0.84_0.11_165)]' />
        </svg>
    )
}

const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label='Hundred Step, home'
            className={cn('group inline-flex items-center gap-2.5 rounded-md outline-none focus-visible:ring-3 focus-visible:ring-ring/40', className)}
        >
            <LogoMark className='transition-transform duration-300 group-hover:-rotate-6' />

            <span className='font-heading text-[1.35rem] leading-none tracking-tight'>
                <span className='font-semibold'>Hundred</span>
                <span className='ml-1 italic text-primary'>Step</span>
            </span>
        </Link>
    )
}

export default Logo
